import { render } from "./OnBoardAppDeployClientv2.vue?vue&type=template&id=78ad9010&scoped=true"
import script from "./OnBoardAppDeployClientv2.vue?vue&type=script&lang=js"
export * from "./OnBoardAppDeployClientv2.vue?vue&type=script&lang=js"

import "./OnBoardAppDeployClientv2.vue?vue&type=style&index=0&id=78ad9010&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ad9010"]])

export default __exports__